<div class="modal-header">
  <h4 class="modal-title">
    {{ taskActionOptions.titleText }}
  </h4>
  <button unity-button class="close" classes="icon-only icon-only-large on_dark" type="button" (click)="cancel()">
    <svg class="unity-icon unity-icon-times">
      <use xlink:href="#unity-icon-times"></use>
    </svg>
  </button>
</div>
<div class="modal-body">
  <dataservice-error></dataservice-error>
  <ng-container *ngIf="_taskActionMode != 'EditProject'">
    <div style="margin: 0px">
      <ep-task-action-edit-panel
        [taskActionMode]="_taskActionMode"
        [taskActionOptions]="taskActionOptions"
      ></ep-task-action-edit-panel>
    </div>
  </ng-container>
  <ng-container *ngIf="_taskActionMode == 'EditProject'">
    <div style="margin: 0px">
      <ep-task-action-edit-panel
        [taskActionMode]="_taskActionMode"
        [taskActionOptions]="taskActionOptions"
      ></ep-task-action-edit-panel>
    </div>
  </ng-container>
</div>
<div class="modal-footer">
  <button unity-button classes="primary" type="button" (click)="actionTaken()">
    {{ taskActionOptions.buttonText }}
  </button>
  <button unity-button classes="ghost" type="button" (click)="cancel()">Cancel</button>
</div>
